import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202604",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 12898,
  clicks: 168,
  adsSpendDollars: 655,
  budgetDollars: 15000,
  salesDollars: 6779,
  bestEstimateRoas: 10.35,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.04,
  newCustomersAcquired: 9,
  reorderConversions: 7,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
